"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPromoBannerType = void 0;
var _types = require("./types");
const getPromoBannerType = (promoBanner)=>{
    var _promoBanner_modules, _banner_content, _banner_backgroundImage, _banner_backgroundVideo, _banner_backgroundImage1, _banner_backgroundVideo1, _banner_content1;
    const banner = promoBanner === null || promoBanner === void 0 ? void 0 : (_promoBanner_modules = promoBanner.modules) === null || _promoBanner_modules === void 0 ? void 0 : _promoBanner_modules[0];
    if (!banner) {
        return undefined;
    }
    if (((_banner_content = banner.content) === null || _banner_content === void 0 ? void 0 : _banner_content.title) && (!!((_banner_backgroundImage = banner.backgroundImage) === null || _banner_backgroundImage === void 0 ? void 0 : _banner_backgroundImage.url) || !!((_banner_backgroundVideo = banner.backgroundVideo) === null || _banner_backgroundVideo === void 0 ? void 0 : _banner_backgroundVideo.id))) {
        return _types.PromoBannerType.Split;
    } else if ((_banner_backgroundImage1 = banner.backgroundImage) === null || _banner_backgroundImage1 === void 0 ? void 0 : _banner_backgroundImage1.url) {
        return _types.PromoBannerType.Image;
    } else if ((_banner_backgroundVideo1 = banner.backgroundVideo) === null || _banner_backgroundVideo1 === void 0 ? void 0 : _banner_backgroundVideo1.id) {
        return _types.PromoBannerType.Video;
    } else if ((_banner_content1 = banner.content) === null || _banner_content1 === void 0 ? void 0 : _banner_content1.title) {
        return _types.PromoBannerType.Text;
    }
    return undefined;
};
exports.getPromoBannerType = getPromoBannerType;
